export const MIN_DEVICE_PRICE = 2856;
export const MIN_DEVICE_PRICE_24 = 2856;
export const MIN_DEVICE_PRICE_36 = 3564;
